var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinePlotKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.078,
    height: 8.459,
    viewBox: "0 0 27.078 8.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line_plot_key",
    "data-name": "line plot key",
    transform: "translate(-1020.216 -309)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y1: 4,
    x2: 13.5,
    transform: "translate(1020.5 312.5)",
    fill: "none",
    stroke: "#46afb8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 13,
    y1: 4,
    transform: "translate(1034 312.5)",
    fill: "none",
    stroke: "#46afb8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1030 309)",
    fill: "#46afb8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePlotKey);
export default __webpack_public_path__ + "static/media/line-plot-key.4bb7e317760a93001def8139bca45b2a.svg";
export { ForwardRef as ReactComponent };